var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$s.takeover},[_c('o-icon',{class:_vm.$s.close,attrs:{"name":"x"},on:{"click":_vm.closeTakeover}}),_c('div',{class:_vm.$s.contentBox},[_c('tiny-pricing-table',{class:_vm.$s.tinyTable}),_c('large-pricing-table',{class:_vm.$s.bigboiTable})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }